import { CaretDownOutlined } from '@ant-design/icons';
import { Dropdown, Layout, Tooltip, Badge, Modal } from 'antd';
import React, { useState, useCallback } from 'react';
import { styled, useHistory } from 'troyfe';
import store from '@/store';
import { imgUrlHandle } from '@/utils';
import MessageDrawer from '@/pages/commodityManage/messageDrawer/index';
import { MenuCord } from './style';
import UserProfile from './userProfile';
import FindPassword from './findPassword';
import AsyncTask from './AsyncTask'

const Header = styled(Layout.Header)`
  height: 48px;
  flex: 0 0 48px;

  .header {
    background: #44bb55;
    width: 100%;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .logo {
      width: 30%;
      height: 100%;
      display: flex;
      align-items: center;
    }

    .trigger {
      font-size: 28px;
      color: #fff;
      margin-left: 10px;
      cursor: pointer;
    }

    .name {
      color: #ffffff;
      font-size: 14px;
    }

    .entrance {
      margin-left: 12px;
      display: flex;
      align-items: center;
      width: 400px;
      height: 28px;
      background: rgba(255, 255, 255, 0.2);

      img {
        width: 16px;
        height: 16px;
        margin-left: 12px;
      }

      input {
        height: 100%;
        cursor: pointer;
        flex: 1;
        margin-left: 16px;
        font-size: 14px;
        border: none;
        color: #fff;
        outline: none;
        background: transparent;

        &::-webkit-input-placeholder {
          color: rgba(255, 255, 255, 0.6);
        }
      }
    }

    .header-navigator {
      display: flex;
      align-items: center;
      margin-right: 14px;
      .hander-icon-container {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        height: 32px;
        width: 32px;
        border-radius: 8px;
        margin-right: 12px;
        &:hover {
          background-color: rgba(0,0,0,0.15);
        }

        img {
          width: 18px;
          height: 18px;
        }
      }
      .header-name-container {
        cursor: pointer;
        .name {
          font-family: PingFangSC, PingFang SC;
          font-size: 14px;
          color: #FFFFFF;
          line-height: 14px;
        }

        .header-drop-down-icon {
          width: 14px;
          height: 14px;
        }
      }
    }
  }

  .ant-badge-count {
    line-height: 17px;
  }
`;
export default function HeaderComponent({ signOut }) {
  const history = useHistory();
  const [visible, setVisible] = useState(false);
  const [userVisible, setUserVisible] = useState(false);
  const [passVisible, setPassVisible] = useState(false);
  const [appState, appDispatchers] = store.useModel('app');
  const { userDetails, user } = appState.basicInformation.userInf;
  const appType = JSON.parse(sessionStorage.getItem('appType'));
  const handleJump = () => {
    let url = '';
    // 物业端
    if (appType == 'MANAGER') {
      url = 'information';
      // 默认第一个
      sessionStorage.setItem('information', 'SYSTEM');
      // 行业端
    } else if (appType == 'MANAGER_SUPERVISE') {
      url = '/HYInformation';
      // 默认第一个
      sessionStorage.setItem('HYInformation', 'SYSTEM');
    } else if (appType == 'MANAGER_SERVICE') {
      setVisible(true);
    }
    if (appType !== 'MANAGER_SERVICE') {
      history.push({
        pathname: url,
      });
    }
  };
  const menu = (
    <MenuCord>
      <div className="user">
        <img src={user && user?.headUrl ? imgUrlHandle(user?.headUrl) : '/headPortrait.png'} alt="img" />
        <div className="user-inf">
          <h1>{user?.phone}</h1>
          <div className="username" title={user?.userName}>
            {user?.userName}
          </div>
        </div>
      </div>
      <ul>
        <li
          onClick={() => {
            if (appType === 'MANAGER_SERVICE') {
              setUserVisible(true);
            } else {
              history.push({
                pathname: '/user/userProfile',
              });
            }
          }}
        >
          编辑资料
        </li>
        <li
          onClick={() => {
            if (appType === 'MANAGER_SERVICE') {
              setPassVisible(true);
            } else {
              history.push({
                pathname: '/user/findPassword',
              });
            }
          }}
        >
          修改密码
        </li>
        <li className="signOut" onClick={() => signOut()}>
          退出系统
        </li>
      </ul>
    </MenuCord>
  );

  const [asyncTaskOpen, setAsyncTaskOpen] = useState(false);
  const handleAsyncTaskOpen = useCallback(() => {
    setAsyncTaskOpen(true);
  }, []);
  const handleCancel = useCallback(() => {
    setAsyncTaskOpen(false);
  }, []);


  return (
    <Header>
      <div className="header">
        <div className="entrance" style={{ visibility: 'hidden' }}>
          <img src="/query.png" alt="gy" />
          测试
          <input placeholder="请输入您想搜索的功能" />
        </div>

        <div className="header-navigator">
          {/* 异步导入任务列表 */}
          <Tooltip placement="bottom" title="导入任务列表">
            <Badge count={0} offset={[-10, 4]} size="small">
              <div onClick={() => handleAsyncTaskOpen()} className="hander-icon-container">
                <img src="/header/header-async-task.png" alt="导入任务列表" />
              </div>
            </Badge>
          </Tooltip>
          <Tooltip placement="bottom" title="帮助文档">
            <a className="hander-icon-container">
              <img src="/header/header-question-circle.png" alt="帮助文档" />
            </a>
          </Tooltip>
          <Tooltip placement="bottom" title="消息">
            <a onClick={handleJump} className="hander-icon-container">
              <img src="/header/header-bell-outlined.png" alt="消息" />
            </a>
          </Tooltip>
          <div className="header-name-container">
            <Dropdown overlay={menu} trigger={['click']}>
              <div>
                {userDetails && userDetails.phone}
                <CaretDownOutlined />
              </div>
            </Dropdown>
          </div>
        </div>
      </div>
      <MessageDrawer visible={visible} setVisible={setVisible} />
      {userVisible && <UserProfile userVisible={userVisible} setUserVisible={setUserVisible} />}
      {passVisible && <FindPassword passVisible={passVisible} setPassVisible={setPassVisible} />}
      <Modal
        title="批量导入列表"
        open={asyncTaskOpen}
        onOk={handleAsyncTaskOpen}
        onCancel={handleCancel}
        width={900}
        destroyOnClose
        centered
        footer={null}
      >
        <AsyncTask />
      </Modal>
    </Header>
  );
}
